import { FormikHelpers } from 'formik';
import React, { FC } from 'react';
import CheckBox from '../../../../library/inputs/checkbox/CheckboxInput';

/*
 ** Component: CheckBoxField
 ** Props
 ** id: field id
 ** enabled: control disabled or not
 ** value: field value
 ** label: label of the checkbox
 ** setFieldValue: function to handle formik value
 */

interface Props {
  id: string;
  enabled: boolean;
  value: boolean;
  label: React.ReactNode;
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  readOnlyMode?: boolean;
}

const CheckBoxField: FC<Props> = ({
  id,
  enabled,
  value,
  label,
  setFieldValue,
  setFieldTouched,
  readOnlyMode,
}: Props) => {
  return (
    <CheckBox
      id={id}
      label={label}
      value={value}
      enabled={enabled}
      onChange={async (e) => {
        await setFieldValue(id, e.target.checked, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default CheckBoxField;
